import * as icons from 'react-bootstrap-icons';
import type { ComponentProps } from 'react';

type IconName = keyof typeof icons;

interface IconProps extends ComponentProps<'svg'> {
  name: IconName;
}

export const Icon = ({ name, ...rest }: IconProps) => {
  const BootstrapIcon = icons[name] as React.ComponentType<ComponentProps<'svg'>>;
  return <BootstrapIcon {...rest} />;
};
